import { motion } from 'framer-motion';
import { useTranslation } from '@/lib/i18n';
import {
  Shield,
  Scaling,
  Cpu,
  Headphones,
  CreditCard,
  Rocket,
} from 'lucide-react';

const features = [
  { key: 'security', icon: Shield, color: 'text-blue-400' },
  { key: 'scalable', icon: Scaling, color: 'text-green-400' },
  { key: 'hardware', icon: Cpu, color: 'text-yellow-400' },
  { key: 'support', icon: Headphones, color: 'text-purple-400' },
  { key: 'prepaid', icon: CreditCard, color: 'text-pink-400' },
  { key: 'performance', icon: Rocket, color: 'text-primary' },
];

export const Features = () => {
  const { t } = useTranslation();

  return (
    <section className="section-spacing relative overflow-hidden" data-testid="features-section">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-card/50 to-background" />
      
      <div className="container-main relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            {t('features.title')}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t('features.subtitle')}
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid-features">
          {features.map((feature, index) => (
            <motion.div
              key={feature.key}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              
              transition={{ delay: index * 0.1 }}
              className="feature-card group"
              data-testid={`feature-${feature.key}`}
            >
              {/* Icon */}
              <div className={`w-14 h-14 rounded-xl bg-white/5 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 ${feature.color}`}>
                <feature.icon className="w-7 h-7" />
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold mb-3">
                {t(`features.${feature.key}.title`)}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {t(`features.${feature.key}.description`)}
              </p>

              {/* Hover Gradient */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl pointer-events-none" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
